import { BrowserRouter, Route, Routes } from "react-router-dom";
import React from 'react';
import Login from "../pages/Login";
import Users from "../pages/dashboard/Users";
import Coins from "../pages/dashboard/Coins";
import ActiveCoin from "../pages/dashboard/ActiveCoin";
import BotLog from "../pages/dashboard/BotLog";
import AnswerQuestion from "../pages/dashboard/AnswerQuestion";
import BotServers from "../pages/dashboard/BotServers";
import { ServerProvider } from "../context/ServerContext";
import { AuthProvider } from "../context/AuthContext";

const AppNavigation: React.FC = () => {
    return (
        <BrowserRouter>
            <AuthProvider>
            <ServerProvider>
                <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/dashboard/users" element={<Users />} />
                    <Route path="/dashboard/coins" element={<Coins />} />
                    <Route path="/dashboard/active_coin" element={<ActiveCoin />} />
                    <Route path="/dashboard/bot_log" element={<BotLog />} />
                    <Route path="/dashboard/answer_question" element={<AnswerQuestion />} />
                    <Route path="/dashboard/bot_servers" element={<BotServers />} />
                </Routes>
            </ServerProvider>
            </AuthProvider>
        </BrowserRouter>
    );
};

export default AppNavigation;
